import Formatters from '../globals/Formatters';
import ServerManager from '../globals/ServerManager';
import StateManager from '../globals/StateManager';
import Toaster from './components/global/ToasterElement.vue';
import Validators from './Validators';

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		/**
		 * Szerokość ekranu, gdzie:
		 * * 1: > 640px,
		 * * 2: > 992px,
		 * * 3: > 1280px
		 * */
		ScreenSize: number;
		/** Zawiera metody ułatwiające pobieranie informacje z serwera używając klasy {@link ServerManager}. */
		Server: ServerManager;
		/** Zawiera metody ułatwiające nawigację używając klasy {@link StateManager}. */
		State: StateManager;
		/** Zawiera metody ułatwiające formatowanie wartości na łańcuchy znaków używając klasy {@link Formatters}. */
		Format: Formatters;
		/** Zawiera metody walidujące wejście formularzy używając klasy {@link Validators}. */
		Validate: Validators;
		/** Zawiera globalny stan aplikacji */
		CurrentState: any;
		/** Komponent do wyświetlania powiadomień w rogu ekranu. */
		Toast: InstanceType<typeof Toaster>;
		/** Informacje o aktualnie zalogowanym użytkowniku. */
		User: any;
		/** Zawiera metody służące do wysyłania analityki. */
		Analytics: any;
		HasFlag(flag: string): boolean;
		toggleBusyState(isBusy: boolean): void;
	}
}

const appMixin = {
	computed: {
		Analytics() {
			return window.Analytics;
		},
		CurrentModule() {
			return this.$root.$data.Module;
		},
		ModuleComponent() {
			return this.$root.$refs.CurrentModule;
		},
		ControllerComponent() {
			return this.$root.$refs.CurrentModule.$refs.CurrentController;
		},
		State() {
			return this.$root.$data.StateManager;
		},
		CurrentState() {
			return (this.State && this.State.CurrentState) ? this.State.CurrentState.state : {};
		},
		Server() {
			return this.$root.$data.ServerManager;
		},
		User() {
			return this.$root.$data.LoggedUser;
		},
		Format() {
			return this.$root.$data.Formatters;
		},
		Validate() {
			return this.$root.$data.Validators;
		},
		ScreenSize() {
			const width = this.$root.$data.WindowWidth;
			if (width > 1680) { return 4; }
			if (width > 1280) { return 3; }
			if (width > 991) { return 2; }
			if (width > 599) { return 1; }
			return 0;
		},
		Toast() {
			return this.$root.$refs.Toaster;
		},
	},
	provide() {
		return {
			toast: this.Toast,
			screenSize: this.ScreenSize,
		};
	},
	methods: {
		HasFlag(flag:string) {
			if (!Array.isArray(this.$root.$data.Flags)) { return false; }
			return this.$root.$data.Flags.indexOf(flag) !== -1;
		},
		toggleBusyState(isBusy: boolean) {
			if (isBusy === undefined) { isBusy = !this.$root.$data.IsSaving; }
			this.$root.$data.IsSaving = isBusy;
		},
	},
};

export default appMixin;
